import apiClient from '@/services/apiService'

class PublishLocalExamService {
  delete(examId: number) {
    throw new Error('Method not implemented.')
  }
async publish(examLocalizationIds: number | number[]): Promise<any> {
  const ids = Array.isArray(examLocalizationIds) ? examLocalizationIds : [examLocalizationIds];

  try {
    const response = await apiClient.post('/exam-localizations/publish', {
      exam_localization_ids: ids
    });

    return response.data;
  } catch (error: any) {
    // Rethrow the full error object to preserve error.response and status info
    throw error;
  }
}

  async unpublish(examLocalizationIds: number | number[]): Promise<any> {
    const ids = Array.isArray(examLocalizationIds) ? examLocalizationIds : [examLocalizationIds]

    const response = await apiClient.post('/exam-localizations/unpublish', {
      exam_localization_ids: ids
    })

    return response.data
  }

async deletelocalexam(examLocalizationIds: number[]): Promise<any> {
  const response = await apiClient.delete(`/exam-localizations`, {
    data: {
      exam_localization_ids: examLocalizationIds
    }
  });
  return response.data;
}

}


export default new PublishLocalExamService()
